import {BaseCachedService} from './Core/BaseCachedService';

class RelationshipService extends BaseCachedService {
    get Url() { return super.Url + "/relationships"; }
    get PrimaryKeyProperty() { return "relationshipId"; }
}

export const service = new RelationshipService();

